import { GET_AVAILABLE_USERS } from '../types'
import { trackPromise } from 'react-promise-tracker'
const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL
// export const getSupervisorGroups = () => {
//   return async (dispatch, getState) => {
//     const { token, accountId } = getState().auth

//     const options = {
//       method: 'GET',
//       mode: 'cors',
//       headers: {
//         'Content-Type': 'application/json',
//         Authorization: `Bearer ${token}`
//       }
//     }

//     const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/groups`, options))

//     if (!response.status || response.status === 401 || response.status === 404 || response.status === 500) {
//       console.error('Failed to get supervisor groups!')
//     } else {
//       const { data } = await response.json()
//       dispatch({
//         type: GET_SUPERVISOR_GROUPS,
//         payload: data
//       })
//     }
//   }
// }

export const getAvailableUsers = (units, statuses) => {
  return async (dispatch, getState) => {
    const { token, accountId, supervisorID } = getState().auth

    // Units and status codes associated with violations being shared
    // These are used to filter supervisors returned to share with
    const body = { units, statuses }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}/groups/available`, options)

    if (!response.status || response.status === 401 || response.status === 404 || response.status === 500) {
      console.error('Failed to get supervisor groups!')
    } else {
      const { data } = await response.json()
      const { userRoleSupervisors } = getState().userListings

      if (data && Object.keys(data).length && userRoleSupervisors) {
        const allSupervisors = []
        userRoleSupervisors.forEach((userInfo) => allSupervisors.push(...userInfo.roleSupervisors))

        const mappedUsers = data.supervisors.map((supervisorInfo) => {
          const currentUser = allSupervisors.find((allInfo) => allInfo.supervisorID === supervisorInfo.supervisorID)

          return ({
            ...currentUser,
            ...supervisorInfo
          })
        })

        const mappedGroups = data.groups.map((groupInfo) => {
          const currentGroup = { ...groupInfo }

          const mappedGroupSupervisors = currentGroup.supervisors.map((supervisorInfo) => {
            const currentUser = allSupervisors.find((allInfo) => allInfo.supervisorID === supervisorInfo.supervisorID)

            return ({
              ...currentUser,
              ...supervisorInfo
            })
          })

          currentGroup.supervisors = mappedGroupSupervisors
          return ({ ...currentGroup })
        })

        const payload = {
          supervisors: mappedUsers,
          groups: mappedGroups,
          templates: data.templates
        }

        dispatch({
          type: GET_AVAILABLE_USERS,
          payload
        })
      }
    }
  }
}

export const shareViolations = (violations, supervisors, message, fireSuccess, fireFailure) => {
  return async (dispatch, getState) => {
    const { token, accountId } = getState().auth

    const body = { violations, supervisors, message }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/share`, options))

    if (!response.status || response.status === 401 || response.status === 404 || response.status === 413 || response.status === 500) {
      fireFailure()
    } else {
      fireSuccess()
    }
  }
}
